import * as moment from 'moment';

import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import {CustomersDetails} from './customersdetails.model';
import { MatDialog } from '@angular/material/dialog';
import { SalesService } from '../../sales.service';
import { SwalComponent } from "@sweetalert2/ngx-sweetalert2";
import notify from 'devextreme/ui/notify';
import { HeaderInterceptorService } from 'src/app/interceptors/header-interceptor';

@Component({
    selector: 'app-add-customers',
    templateUrl: './add-customers.component.html',
    styleUrls: ['./add-customers.component.scss']
})
export class AddCustomersComponent implements OnInit {

    editContact: boolean = false;
    selectedBranchData: any;
    editCustomerBranch: boolean;
    customerBranchesData: any;
    customerBranches: any;
    salesDriver: any;
    salesMan: any;
    vattaxGroup: any;
    currency: any;
    paymentType: any;
    addCustomerBranchContent: FormGroup;
    branchPopUp: boolean;
    loadingIndicator: boolean;
    customerData: any;
    tempCities: any = [];
    tempProvince: any = [];
    addCustomerContent: FormGroup;
    addPurchaseOrderForm: FormGroup;
    vendors: any[];
    country: any [];
    Orders: any [];
    date = new Date();
    customersDetails: CustomersDetails[];
    showTemp: boolean;
    showCash: boolean = false;
    showCheck: boolean = false;
    showChildTemp: boolean;
    popupVisible: boolean;
    customerContentPaylod: any;
    customerId: any;
    private rows: any;
     departments: any;
    designation: any;
    isEdit: boolean;
    Province: any;
    cities: any;
    countries: any;
    branches: any;
    color: any [];
    customerType : any [];
    customerContactsObj : any [];
    customerBranchListObj: any [];
    provinceList: any[];
    cityList: any[];
    tempCityList: any[];
    tempProvinceList: any[];
    @ViewChild("saveSwal") private saveSwal: SwalComponent;
    defaultSelectedItem: any;
    // purchaseDetails: any[any];
    constructor(public dialog: MatDialog, private router: Router,
         private activatedRoute: ActivatedRoute, private saleService: SalesService, private customAxios: HeaderInterceptorService) {
    }
    ngOnInit() {
        this.addPurchaseOrderFormInitialization();
        this.addCustomerBranchFormInitialization();
        this.addCustomerContactFormInitialize();
        this.customerId = this.activatedRoute.snapshot.params.id;
        this.customersDetails = [];
        this.customerContactsObj = [];
        this.customerBranchListObj = [];
        this.provinceList = [];
        this.cityList = [];
        this.tempCityList = [];
        this.tempProvinceList = [];
        this.currency = [];
        this.isEdit = false;
        this.getAllVendors();
        this.getAllBrands();
        this.getAllDesignation();
        this.getAllDepartments();
        this.getAllCompanyBranches();
        this.getAllCOuntries();
        this.getAllCustomerType();
        this.getAllPaymentType();
        // this.getAllCurrency();
        this.getAllVattaxGroup();
        this.getAllSalesman();
        this.getAllSalesDriver();
        this.getAllProvince();
        this.getAllCities();
        if (this.customerId){        
            this.getCustomerInfoById(this.customerId);
            this.getAllCustomerBranch();
        }
    }

    /**
     * @name getCustomerInfoById
     * @description get customer info with respect to Id
    */
    getCustomerInfoById(customerId: number) {
        this.loadingIndicator = true;
        this.customAxios.get('Customer/GetCustomerById?id=' + customerId)
            .then((response: any) => {
                if (response.data.completed) {
                    this.customerData = response.data.payload;
                    //binding customer data by api response
                    this.addPurchaseOrderFormInitialization(response.data.payload);
                    //binding customer contacts details on grid
                    let object;
                    if (this.customerData.customerContacts && this.customerData.customerContacts.length > 0){
                        this.customerData.customerContacts.forEach((item) => {
                            object = {
                                customerContactId: item.customerContactId,
                                customerId: item.customerId,
                                contactName: item.contactName,
                                designationId: item.designationId,
                                emailAddress: item.emailAddress,
                                phoneNumber: item.phoneNumber,
                                mobileNumber: item.mobileNumber,
                                faxNumber: item.faxNumber,
                                departmentId: item.departmentId,
                                ext: item.ext
                            }
                            this.customerContactsObj.push(object)
                        });
                    }
                    this.loadingIndicator = false;
                }
            });
    
    }

    /**
     * @name addPurchaseOrderFormInitialization
     * @description initializes customer form
    */
    addPurchaseOrderFormInitialization(data?: any){
        this.addPurchaseOrderForm = new FormGroup({
            customerName: new FormControl(data ? data.customerName : '', [Validators.required]),
            arabicCustomerName: new FormControl(data ? data.arabicCustomerName : '', []),
            abb: new FormControl(data ? data.abb : '', []),
            postalAddress: new FormControl(data ? data.postalAddress : '', [Validators.required]),
            postalAddressArabic: new FormControl(data ? data.postalAddressArabic : '', []),
            countryId: new FormControl(data ? data.countryId : '', [Validators.required]),
            provinceId: new FormControl(data ? data.provinceId : '', [Validators.required]),
            cityId: new FormControl(data ? data.cityId : '', [Validators.required]),
            postalCode: new FormControl(data ? data.postalCode : '', []),
            companyBranchId: new FormControl(data ? data.companyBranchId : '', []),
            defaultCurrencyId: new FormControl(data ? data.defaultCurrencyId : '', []),
            vatnumber: new FormControl(data ? data.vatnumber : '', []),
            emailAddress: new FormControl(data ? data.emailAddress : '', []),
            contactNo: new FormControl(data ? data.contactNo : '', []),
            faxNo: new FormControl(data ? data.faxNo : '', []),
            customerCRNO: new FormControl(data ? data.customerCRNO : '', []),
            website: new FormControl(data ? data.website : '', []),
            poBox: new FormControl(data ? data.poBox : '', []),
            customerTypeId: new FormControl(data ? data.customerTypeId : '', [Validators.required]),
            customerContacts: new FormControl('', []),
            customerEmail: new FormControl(data ? data.customerEmail : '', []),
            vattaxGroupId: new FormControl(data ? data.vattaxGroupId : '', []),
            isRegisteredWithSalesTax: new FormControl(data ? data.isRegisteredWithSalesTax : false, []),
            ntn: new FormControl(data ? data.ntn : '', []),
            vatno: new FormControl(data ? data.vatno : '', []),
            paymentTypeId: new FormControl(data ? data.paymentTypeId : '', [Validators.required]),
            isBt: new FormControl(data ? data.isBt : false, []),
            hobusiness: new FormControl(data ? data.hobusiness : false, []),
            daysReminder1: new FormControl(data ? data.customerPaymentTerm.daysReminder1 : '', []),
            daysReminder2: new FormControl(data ? data.customerPaymentTerm.daysReminder2 : '', []),
            amountReminder1: new FormControl(data ? data.customerPaymentTerm.amountReminder1 : '', []),
            amountReminder2: new FormControl(data ? data.customerPaymentTerm.amountReminder2 : '', []),
            blockAmount: new FormControl(data ? data.customerPaymentTerm.blockAmount : '', []),
            unBlockAmount: new FormControl(data ? data.customerPaymentTerm.unBlockAmount : '', []),
            unBlockPercentage: new FormControl(data ? data.customerPaymentTerm.unBlockPercentage : '', []),
            blockDays: new FormControl(data ? data.customerPaymentTerm.blockDays : '', []),
            unBlockDays: new FormControl(data ? data.customerPaymentTerm.unBlockDays : '', []),
            graceAmount: new FormControl(data ? data.customerPaymentTerm.graceAmount : '', []),
            cashAgingDays: new FormControl(data ? data.customerPaymentTerm.cashAgingDays : '', []),
            mlragingDays: new FormControl(data ? data.customerPaymentTerm.mlragingDays : '', []),
            mlrinvCount: new FormControl(data ? data.customerPaymentTerm.mlrinvCount : '', []),
            mlramount: new FormControl(data ? data.customerPaymentTerm.mlramount : '', []),
            mlrblockAmount: new FormControl(data ? data.customerPaymentTerm.mlrblockAmount : '', []),
            mlardays: new FormControl(data ? data.customerPaymentTerm.mlardays : '', []),
            mlarinvCount: new FormControl(data ? data.customerPaymentTerm.mlarinvCount : '', []),
            mlaramount: new FormControl(data ? data.customerPaymentTerm.mlaramount : '', []),
            mlrautoUnBlockin: new FormControl(data ? data.customerPaymentTerm.mlrautoUnBlockin : '', []),
        });
    }

    /**
     * @name addCustomerBranchFormInitialization
     * @description initializes customer branch form
    */
    addCustomerBranchFormInitialization(branchData?: any){
        this.addCustomerBranchContent = new FormGroup({
            customerId: new FormControl(this.customerId ? this.customerId : 0, [Validators.required]),
            salesmanId: new FormControl(branchData ? branchData.salesmanId : '', [Validators.required]),
            salesDriverId: new FormControl(branchData ? branchData.salesDriverId : '', []),
            customerBranchId: new FormControl(branchData ? branchData.customerBranchId : 0, []),
            branchName: new FormControl(branchData ? branchData.branchName : '', [Validators.required]),
            arabicBranchName: new FormControl(branchData ? branchData.arabicBranchName : '', []),
            postalAddress: new FormControl(branchData ? branchData.postalAddress : '', [Validators.required]),
            cityId: new FormControl(branchData ? branchData.cityId : '', [Validators.required]),
            postalCode: new FormControl(branchData ? branchData.postalCode : '', []),
            companyBranchId: new FormControl(branchData ? branchData.companyBranchId : '', []),
            emailAddress: new FormControl(branchData ? branchData.emailAddress : '', [Validators.email]),
            contactNo: new FormControl(branchData ? branchData.contactNo : '', []),
            faxNo: new FormControl(branchData ? branchData.faxNo : '', []),
            // customerEmail: new FormControl('', [Validators.email, Validators.required]),
            poBox: new FormControl(branchData ? branchData.poBox : '', []),
            noOfInvoice: new FormControl(branchData ? branchData.noOfInvoice : '', []),
            specialInstruction: new FormControl(branchData ? branchData.specialInstruction : '', []),
            isCustomerLocked: new FormControl(branchData ? branchData.isCustomerLocked : false, []),
            isHeadOffice: new FormControl(branchData ? branchData.isHeadoffice : false, []),
            accountCode: new FormControl(branchData ? branchData.accountCode : '', []),
            openingBalance: new FormControl(branchData ? branchData.openingBalance : '', [Validators.required]),
            openingBalanceDate: new FormControl(branchData ? branchData.openingBalanceDate : moment(new Date()).format('YYYY-MM-DD'), [Validators.required]),
            active: new FormControl(branchData ? branchData.active : true, []),
        });
    }
    
    /**
     * @name resetInvoiceFields
     * @returns void
     * @description reset
     */
    resetInvoiceFields() {
        this.addPurchaseOrderForm.get('mlragingDays').setValue('');
        this.addPurchaseOrderForm.get('mlrinvCount').setValue('');
        this.addPurchaseOrderForm.get('mlramount').setValue('');
        this.addPurchaseOrderForm.get('mlrblockAmount').setValue('');
        this.addPurchaseOrderForm.get('mlrautoUnBlockin').setValue('');
        this.addPurchaseOrderForm.get('mlardays').setValue('');
        this.addPurchaseOrderForm.get('mlarinvCount').setValue('');
        this.addPurchaseOrderForm.get('mlaramount').setValue('');
        this.addPurchaseOrderForm.get('cashAgingDays').setValue('');
    }
     /**
     * @name resetCreditFields
     * @returns void
     * @description reset
     */
    resetCreditFields() {
        this.addPurchaseOrderForm.get('amountReminder1').setValue('');
        this.addPurchaseOrderForm.get('amountReminder2').setValue('');
        this.addPurchaseOrderForm.get('daysReminder1').setValue('');
        this.addPurchaseOrderForm.get('daysReminder2').setValue('');
        this.addPurchaseOrderForm.get('blockDays').setValue('');
        this.addPurchaseOrderForm.get('unBlockAmount').setValue('');
        this.addPurchaseOrderForm.get('unBlockDays').setValue('');
        this.addPurchaseOrderForm.get('graceAmount').setValue('');
    }
    /**
     * @name addCustomerContactFormInitialize
     * @description initializes customer contact form
    */
    addCustomerContactFormInitialize(contactData?: any){
        this.addCustomerContent = new FormGroup({
            customerContactId: new FormControl(contactData ? contactData.customerContactId : 0, [Validators.required]),
            customerBranchId: new FormControl(contactData ? contactData.customerBranchId : 0, []),
            customerId: new FormControl(contactData ? contactData.customerId : 0, [Validators.required]), 
            contactName: new FormControl(contactData ? contactData.contactName : '', [Validators.required]),
            designationId: new FormControl(contactData ? contactData.designationId : '', []),
            emailAddress: new FormControl(contactData ? contactData.emailAddress : '', [Validators.email]),
            phoneNumber: new FormControl(contactData ? contactData.phoneNumber : '', []),
            mobileNumber: new FormControl(contactData ? contactData.mobileNumber : '', []),
            faxNumber: new FormControl(contactData ? contactData.faxNumber : '', []),
            departmentId: new FormControl(contactData ? contactData.departmentId : '', [Validators.required]),
            ext: new FormControl(contactData ? contactData.ext : '', [])
        });
    }

    /**
     * @name getAllVendors
     * @description get vendors list
    */
    getAllVendors() {
        this.customAxios.get('Vendor/GetAllVendors').then((response: any) => {
            if (response.data.completed) {
                // this.vendors = response.data.payload;
                if (response.data.payload.length > 0) {
                    const list = [];
                    response.data.payload.forEach(element => {
                    if (element.active) {
                        list.push(element);
                    }
                    });
                    this.vendors = list;
                } 
                else {
                    if (response.data.payload.active) {
                    this.vendors = response.data.payload;
                    }
                }
            }
        });
    }

    /**
     * @name toggle
     * @param label
     * @description toggles card in customer form
    */
    toggle(label: string) {
        if (label === 'showTemp') {
            this.showTemp = !this.showTemp;
        }
        if (label === 'showCash') {
            this.showCash = !this.showCash;
        }
        if (label === 'showCheck') {
            this.showCheck = !this.showCheck;
        }
        if (label === 'showChildTemp') {
            this.showChildTemp = !this.showChildTemp;
        }
    }

    /**
     * @name addCustomerInfo
     * @param form
     * @description saves customer contact
    */
    addCustomerInfo(form: FormGroup) {
        this.loadingIndicator = true;
        const payload = {
            customerTypeId: form.value.customerTypeId,
            customerId: this.customerId ? this.customerId : 0,
            customerName: form.value.customerName,
            arabicCustomerName: form.value.arabicCustomerName,
            abb: form.value.abb,
            postalAddress: form.value.postalAddress,
            postalAddressArabic: form.value.postalAddressArabic,
            countryId: form.value.countryId,
            provinceId: form.value.provinceId,
            cityId: form.value.cityId,
            postalCode: form.value.postalCode,
            companyBranchId: form.value.companyBranchId ,
            defaultCurrencyId: 1,
            vatnumber: form.value.vatnumber,
            emailAddress: '',
            contactNo: 123,
            faxNo: '',
            customerEmail: '',
            customerCRNO: form.value.customerCRNO,
            website: form.value.website,
            poBox: form.value.poBox,
            vattaxGroupId: 1,
            isRegisteredWithSalesTax: this.addPurchaseOrderForm.value.isRegisteredWithSalesTax,
            ntn: this.addPurchaseOrderForm.value.ntn,
            vatno: '',
            paymentTypeId: this.addPurchaseOrderForm.value.paymentTypeId,
            isBt: this.addPurchaseOrderForm.value.isBt,
            hobusiness: this.addPurchaseOrderForm.value.hobusiness,
            customerPaymentTerm: {
                customerId: this.customerId ? this.customerId : 0,
                customerPaymentTermId: this.customerData ? this.customerData.customerPaymentTerm.customerPaymentTermId : 0,
                daysReminder1: this.addPurchaseOrderForm.value.daysReminder1,
                daysReminder2: this.addPurchaseOrderForm.value.daysReminder2,
                amountReminder1: this.addPurchaseOrderForm.value.amountReminder1,
                amountReminder2: this.addPurchaseOrderForm.value.amountReminder2,
                blockAmount: this.addPurchaseOrderForm.value.blockAmount,
                unBlockAmount: this.addPurchaseOrderForm.value.unBlockAmount,
                unBlockPercentage: this.addPurchaseOrderForm.value.unBlockPercentage,
                blockDays: this.addPurchaseOrderForm.value.blockDays,
                unBlockDays: this.addPurchaseOrderForm.value.unBlockDays,
                graceAmount: this.addPurchaseOrderForm.value.graceAmount,
                cashAgingDays: this.addPurchaseOrderForm.value.cashAgingDays,
                mlragingDays: this.addPurchaseOrderForm.value.mlragingDays,
                mlrinvCount: this.addPurchaseOrderForm.value.mlrinvCount,
                mlramount: this.addPurchaseOrderForm.value.mlramount,
                mlrblockAmount: this.addPurchaseOrderForm.value.mlrblockAmount,
                mlardays: this.addPurchaseOrderForm.value.mlardays,
                mlarinvCount: this.addPurchaseOrderForm.value.mlarinvCount,
                mlaramount: this.addPurchaseOrderForm.value.mlaramount,
                mlrautoUnBlockin: this.addPurchaseOrderForm.value.mlrautoUnBlockin,
                addDateTime: new Date().toISOString(),
                addUserId: JSON.parse(localStorage.getItem('userData')).userId,
                updateDateTime: new Date().toISOString(),
                updateUserId: JSON.parse(localStorage.getItem('userData')).userId,
                active: true
              },
            addDateTime: new Date().toISOString(),
            addUserId: JSON.parse(localStorage.getItem('userData')).userId,
            updateDateTime: new Date().toISOString(),
            updateUserId: JSON.parse(localStorage.getItem('userData')).userId,
            active: true
        };
        console.log('addCustomerInfo', payload)
        //For updating customer details
        if(this.customerId){
            this.customAxios.post('Customer/UpdateCustomer', payload).then((response) => {
                console.log(response);
                if (response.data.completed) {
                    this.loadingIndicator = false;
                    this.saveSwal.swalOptions = {
                        icon: "success",
                        titleText: response.data.message,
                        showConfirmButton: false,
                        showCancelButton: false,
                        timer: 1500
                    };
                    this.saveSwal.fire().then((res: any) => {
                        this.router.navigate(["/portal/sales/customers"]);
                    });
                }
                else {
                    this.loadingIndicator = false;
                    notify(response.data.message, 'error', 3000);
                    console.error(response);
                  }
            }).catch(error => {
                this.loadingIndicator = false;
                    notify(error.error, 'error', 3000);
            });
        }
        //For adding customer details
        else{
            this.customAxios.post('Customer/AddCustomer', payload)
            .then((response) => {
                console.log(response);
                if (response.data.completed) {
                    this.loadingIndicator = false;
                    this.saveSwal.swalOptions = {
                        icon: "success",
                        titleText: response.data.message,
                        showConfirmButton: false,
                        showCancelButton: false,
                        timer: 1500
                    };
                    this.saveSwal.fire().then((res: any) => {
                        this.router.navigate(['/portal/sales/customers/edit/' + response.data.payload]);
                    });
                } else {
                    this.loadingIndicator = false;
                    notify(response.data.message, 'error', 3000);
                    console.error(response);
                  }
    
    
            }).catch(error => {
                this.loadingIndicator = false;
                    notify(error.error, 'error', 3000);
            });
        }
     }

    /**
     * @name getAllDesignation
     * @description get designation list
    */
    getAllDesignation() {
        this.customAxios.get('Designation/GetAllDesignations').then((response: any) => {
            if (response.data.completed) {
                if (response.data.payload.length > 0) {
                    const list = [];
                    response.data.payload.forEach(element => {
                        if (element.active) {
                        list.push(element);
                        }
                    });
                    this.designation = list;
                    } else {
                    if (response.data.payload.active) {
                        this.designation = response.data.payload;
                    }
                    }
            }
        });
    }

    /**
     * @name getAllCOuntries
     * @description get countries list
    */
    getAllCOuntries() {
        this.customAxios.get('Country/GetAllCountries')
            .then((response: any) => {
                if (response.data.completed) {
                    // this.countries = response.data.payload;
                    if (response.data.payload.length > 0) {
                        const list = [];
                        response.data.payload.forEach(element => {
                          if (element.active) {
                            list.push(element);
                          }
                        });
                        this.countries = list;
                      } else {
                        if (response.data.payload.active) {
                          this.countries = response.data.payload;
                        }
                      }
                }
            });
    }

    /**
     * @name getAllCustomerType
     * @description get customer type list
    */
    getAllCustomerType() {
        this.customAxios.get('CustomerType/GetAllCustomerTypes')
            .then((response: any) => {
                if (response.data.completed) {
                    // this.customerType = response.data.payload;
                    if (response.data.payload.length > 0) {
                        const list = [];
                        response.data.payload.forEach(element => {
                          if (element.active) {
                            list.push(element);
                          }
                        });
                        this.customerType = list;
                      } else {
                        if (response.data.payload.active) {
                          this.customerType = response.data.payload;
                        }
                      }

                }
            });
    }

    /**
     * @name getAllCities
     * @description get cities list
    */
    getAllCities() {
        this.customAxios.get('City/GetAllCities')
            .then((response: any) => {
                if (response.data.completed) {
                    // this.cities = response.data.payload;
                    // this.tempCities = response.data.payload;
                    if (response.data.payload.length > 0) {
                        const list = [];
                        response.data.payload.forEach(element => {
                          if (element.active) {
                            list.push(element);
                          }
                        });
                        this.cities = list;
                        this.tempCities = list;
                        // fixing
                        this.cityList = list;
                        this.tempCityList = list;
                      } else {
                        if (response.data.payload.active) {
                          this.cities = response.data.payload;
                          this.tempCities = response.data.payload;
                          this.cityList = response.data.payload;
                           this.tempCityList = response.data.payload;
                        }
                      }
                }
            });
    }

    /**
     * @name getAllDepartments
     * @description get departments list
    */
    getAllDepartments() {
        this.customAxios.get('Department/GetAllDepartments')
            .then((response: any) => {
                if (response.data.completed) {
                    // this.departments = response.data.payload;
                    if (response.data.payload.length > 0) {
                        const list = [];
                        response.data.payload.forEach(element => {
                          if (element.active) {
                            list.push(element);
                          }
                        });
                        this.departments = list;
                      } else {
                        if (response.data.payload.active) {
                          this.departments = response.data.payload;
                        }
                      }

                }
            });
    }

    /**
     * @name getAllCompanyBranches
     * @description get company branches list
    */
    getAllCompanyBranches() {
        this.customAxios.get('CompanyBranch/GetAllCompanyBranches')
            .then((response: any) => {
                if (response.data.completed) {
                    // this.branches = response.data.payload;
                    if (response.data.payload.length > 0) {
                        const list = [];
                        response.data.payload.forEach(element => {
                          if (element.active) {
                            list.push(element);
                          }
                        });
                        this.branches = list;
                      } else {
                        if (response.data.payload.active) {
                          this.branches = response.data.payload;
                        }
                      }
                }
            });
    }

    /**
     * @name getAllProvince
     * @description get province list
    */
    getAllProvince() {
        this.customAxios.get('Province/GetAllProvince')
            .then((response: any) => {
                if (response.data.completed) {
                    // this.Province = response.data.payload;
                    // this.tempProvince = response.data.payload;
                    if (response.data.payload.length > 0) {
                        const list = [];
                        response.data.payload.forEach(element => {
                          if (element.active) {
                            list.push(element);
                          }
                        });
                        this.Province = list;
                        this.tempProvince = list;
                        // fixing
                        this.provinceList = list;
                        this.tempProvinceList = list;
                        // 
                      } else {
                        if (response.data.payload.active) {
                          this.Province = response.data.payload;
                          this.tempProvince = response.data.payload;
                          this.provinceList = response.data.payload;
                          this.tempProvinceList = response.data.payload;
                        }
                      }
                }
            });
    }

    /**
     * @name getAllBrands
     * @description get brands list
    */
    getAllBrands() {
        this.customAxios.get('Country/GetAllCountries').then((response: any) => {
            if (response.data.completed) {
                // this.country = response.data.payload;
                if (response.data.payload.length > 0) {
                  const list = [];
                  response.data.payload.forEach(element => {
                    if (element.active) {
                      list.push(element);
                    }
                  });
                  this.country = list;
                } else {
                  if (response.data.payload.active) {
                    this.country = response.data.payload;
                  }
                }
                // this.rows = this.rows.filter (filter => {
                //     return filter.active;
            }
        });
    }

    /**
     * @name getAllPaymentType
     * @description get payment type list
    */
    getAllPaymentType() {
        this.customAxios.get('PaymentType/GetAllPaymentTypes')
        .then((response: any) => {
            if (response.data.completed) {
                // this.paymentType = response.data.payload;
                if (response.data.payload.length > 0) {
                    const list = [];
                    response.data.payload.forEach(element => {
                      if (element.active) {
                        list.push(element);
                      }
                    });
                    this.paymentType = list;
                  } else {
                    if (response.data.payload.active) {
                      this.paymentType = response.data.payload;
                    }
                  }
            }
        });
    }

    /**
     * @name getAllCurrency
     * @description get currency list
    */
    getAllCurrency(countryId: number) {
        this.currency = [];
        this.customAxios.get(`Currency/GetCurrencyByCountryId?countryId=${countryId}`).then((response: any) => {
            if (response.data.completed) {
                // this.currency = response.data.payload;
                if (response.data.payload.length > 0) {
                    const list = [];
                    response.data.payload.forEach(element => {
                      if (element.active) {
                        list.push(element);
                      }
                    });
                    this.currency = list;
                  } else {
                    if (response.data.payload.active) {
                      this.currency = response.data.payload;
                    }
                  }
                  this.defaultSelectedItem = this.currency[0].currencyId;
            }
        });
        
    }

    /**
     * @name getAllVattaxGroup
     * @description get vat tax group list
    */
    getAllVattaxGroup() {
        this.customAxios.get('VattaxGroup/GetAllVattaxGroup').then((response: any) => {
            if (response.data.completed) {
                // this.vattaxGroup = response.data.payload;
                if (response.data.payload.length > 0) {
                    const list = [];
                    response.data.payload.forEach(element => {
                      if (element.active) {
                        list.push(element);
                      }
                    });
                    this.vattaxGroup = list;
                  } else {
                    if (response.data.payload.active) {
                      this.vattaxGroup = response.data.payload;
                    }
                  }
            }
        });
    }

    /**
     * @name getAllSalesman
     * @description get salesman list
    */
    getAllSalesman() {
        this.customAxios.get('Account/GetSalesman').then((response: any) => {
            if (response.data.completed) {
                // this.salesMan = response.data.payload;
                if (response.data.payload.length > 0) {
                    const list = [];
                    response.data.payload.forEach(element => {
                      if (element.active) {
                        list.push(element);
                      }
                    });
                    this.salesMan = list;
                  } else {
                    if (response.data.payload.active) {
                      this.salesMan = response.data.payload;
                    }
                  }
            }
        });
    }

    /**
     * @name getAllSalesDriver
     * @description get sales driver list
    */
    getAllSalesDriver(){
        this.customAxios.get('Account/GetSalesDriver').then((response: any) => {
            if (response.data.completed) {
                // this.salesDriver = response.data.payload;
                if (response.data.payload.length > 0) {
                  const list = [];
                  response.data.payload.forEach(element => {
                    if (element.active) {
                      list.push(element);
                    }
                  });
                  this.salesDriver = list;
                } else {
                  if (response.data.payload.active) {
                    this.salesDriver = response.data.payload;
                  }
                }
                
            }
        });
    }

    /**
     *@name filterProvinces
    * @returns filter province list
    *
    */
    filterProvinces(countryId?: any) {
        if (countryId) {
            this.getAllCurrency(countryId);
        }
        
        if (countryId && this.tempProvince && this.tempProvinceList.length > 0) {
        this.provinceList = [];
        this.cityList = [];
        let filteredProvinces = this.tempProvinceList.filter(x => {
            return x.countryId == countryId;
        });
        return (this.provinceList = filteredProvinces);
        }
    }

    /**
     *@name filterProvinces
     * @returns filter citylist list
    */
    filterCity(provenceId?: any) {
        if (provenceId && this.tempCityList && this.tempCityList.length > 0) {
            this.cityList = [];
            let filteredCity = this.tempCityList.filter(x => {
            return x.provenceId == provenceId;
        });
            return (this.cityList = filteredCity);
        }
    }

    saveCustomerBranchForm(form: FormGroup){
        this.loadingIndicator = true;
        const payload = {
            customerId: this.customerId ? this.customerId : 0,
            salesmanId: form.value.salesmanId,
            salesDriverId: form.value.salesDriverId ? form.value.salesDriverId : 1,
            customerBranchId: form.value.customerBranchId ? form.value.customerBranchId : 0,
            branchName: form.value.branchName,
            arabicBranchName: form.value.arabicBranchName,
            postalAddress: form.value.postalAddress,
            cityId: form.value.cityId,
            postalCode: form.value.postalCode,
            companyBranchId: form.value.companyBranchId,
            emailAddress: form.value.emailAddress,
            contactNo: form.value.contactNo,
            faxNo: form.value.faxNo,
            // customerEmail: form.value.customerEmail,
            poBox: form.value.poBox,
            noOfInvoice: form.value.noOfInvoice,
            specialInstruction: form.value.specialInstruction,
            isCustomerLocked: form.value.isCustomerLocked,
            isHeadOffice: form.value.isHeadOffice,
            
            accountCode: '',

            openingBalance: form.value.openingBalance,
            openingBalanceDate: form.value.openingBalanceDate,
            // customerContactList: this.customerBranchesData ? this.customerBranchesData.customerContactList : [],
            addDateTime: new Date().toISOString(),
            addUserId: JSON.parse(localStorage.getItem('userData')).userId,
            updateDateTime: new Date().toISOString(),
            updateUserId: JSON.parse(localStorage.getItem('userData')).userId,
            active: form.value.active
        }
        if (this.editCustomerBranch){
            this.customAxios.post('CustomerBranch/UpdateCustomerBranch', payload).then((response) => {
                console.log(response);
                if (response.data.completed) {
                    this.loadingIndicator = false;
                    this.branchPopUp = false;
                    this.addCustomerBranchFormInitialization();
                    // this.back();
                    this.getAllCustomerBranch();
                    this.saveSwal.swalOptions = {
                        icon: "success",
                        titleText: response.data.message,
                        showConfirmButton: false,
                        showCancelButton: false,
                        timer: 1500
                    };
                    this.saveSwal.fire();
                }else {
                    this.loadingIndicator = false;
                    notify(response.data.message, 'error', 3000);
                    console.error(response);
                  }
            }).catch(error => {
                this.loadingIndicator = false;
                    notify(error.error, 'error', 3000);
            });
        }
        else{
            this.customAxios.post('CustomerBranch/AddCustomerBranch', payload).then((response) => {
                console.log(response);
                if (response.data.completed) {
                    this.loadingIndicator = false;
                    this.branchPopUp = false;
                    this.addCustomerBranchFormInitialization();
                    this.saveSwal.swalOptions = {
                        icon: "success",
                        titleText: response.data.message,
                        showConfirmButton: false,
                        showCancelButton: false,
                        timer: 1500
                    };
                    this.saveSwal.fire();
                    // this.back();
                    this.getAllCustomerBranch();
                }
                else {
                    this.loadingIndicator = false;
                    notify(response.data.message, 'error', 3000);
                    console.error(response);
                  }
            }).catch(error => {
                this.loadingIndicator = false;
                    notify(error.error, 'error', 3000);
    
            });
        }
    }

    getDepartmentName (department) {
        const filterDepartment = this.departments.find(item => item.departmentId == department.departmentId);
        if (filterDepartment) {
            return filterDepartment.departmentName;
        } else {
            return 'Department not found';
        }
    }

    getDesignationName (des) {
      const filterDesination = this.designation.find(item => item.designationId == des.designationId);
        if (filterDesination){
            return filterDesination.designationName;
        }
        else {
            return 'Designation not found'
        }
    }

    get customerName() {
        return this.addPurchaseOrderForm.get('customerName');
    }

    get arabicCustomerName() {
        return this.addPurchaseOrderForm.get('arabicCustomerName');
    }

    get abb() {
        return this.addPurchaseOrderForm.get('abb');
    }

    get postalAddress() {
        return this.addPurchaseOrderForm.get('postalAddress');
    }

    get postalAddressArabic() {
        return this.addPurchaseOrderForm.get('postalAddressArabic');
    }

    get countryId() {
        return this.addPurchaseOrderForm.get('countryId');
    }

    get provinceId() {
        return this.addPurchaseOrderForm.get('provinceId');
    }

    get cityId() {
        return this.addPurchaseOrderForm.get('cityId');
    }
    
    get postalCode() {
        return this.addPurchaseOrderForm.get('postalCode');
    }

    get companyBranchId() {
        return this.addPurchaseOrderForm.get('companyBranchId');
    }

    get defaultCurrencyId() {
        return this.addPurchaseOrderForm.get('defaultCurrencyId');
    }

    get vatnumber() {
        return this.addPurchaseOrderForm.get('vatnumber');
    }

    // get emailAddress() {
    //     return this.addPurchaseOrderForm.get('emailAddress');
    // }

    get faxNo() {
        return this.addPurchaseOrderForm.get('faxNo');
    }

    get website() {
        return this.addPurchaseOrderForm.get('website');
    }

    get poBox() {
        return this.addPurchaseOrderForm.get('poBox');
    }

    get customerContacts() {
        return this.addPurchaseOrderForm.get('customerContacts');
    }

    get contactName() {
        return this.addPurchaseOrderForm.get('contactName');
    }

    get designationId() {
        return this.addPurchaseOrderForm.get('designationId');
    }

    get emailAddress() {
        return this.addPurchaseOrderForm.get('emailAddress');
    }

    get customerTypeId() {
        return this.addPurchaseOrderForm.get('customerTypeId');
    }

    get mobileNumber() {
        return this.addPurchaseOrderForm.get('mobileNumber');
    }

    get faxNumber() {
        return this.addPurchaseOrderForm.get('faxNumber');
    }

    get departmentId() {
        return this.addPurchaseOrderForm.get('departmentId');
    }
    
    get ext() {
        return this.addPurchaseOrderForm.get('ext');
    }

    get phoneNumber() {
        return this.addPurchaseOrderForm.get('phoneNumber');
    }

    get customerEmail() {
        return this.addPurchaseOrderForm.get('customerEmail');
    }

    get active() {
        return this.addPurchaseOrderForm.get('active');
    }

    /**
     * @name showPaymentType
     * @param event
     * @description toggles cash and check cards
    */
    showPaymentType(event: any){
        if (event == 1){
            this.showCheck = true;
            this.resetInvoiceFields();
            this.showCash = false;
        }
        else{
            this.showCash = true;
            this.resetCreditFields();
            this.showCheck = false;
            
        }
    }

    /**
     * @name getAllCustomerBranch
     * @description toggles cash and check cards
    */
    getAllCustomerBranch(){
        this.loadingIndicator = true;
        this.customAxios.get(`CustomerBranch/GetCustomerBranchByCustomerId?customerId=${this.customerId}`).then((response: any) => {
            if (response.data.completed) {
                this.customerBranches = response.data.payload;
                this.customerBranches.map(item => {
                    if (item.customerContactList == null){
                        item.customerContactList = [];
                    }
                })
                this.loadingIndicator = false;
            } else {
                this.loadingIndicator = false;
            }
        });
    }

    /**
     * @name editBranch
     * @param branchId
     * @description get branch id data by id and displays in popup
    */
    editBranch(branchId: number){
        this.editCustomerBranch = true;
        this.loadingIndicator = true;
        this.customAxios.get(`CustomerBranch/GetCustomerBranchById?id=${branchId}`).then((response: any) => {
            if (response.data.completed) {
                this.customerBranchesData = response.data.payload;
                this.addCustomerBranchFormInitialization(this.customerBranchesData);
                this.branchPopUp = true;
                this.loadingIndicator = false;
            } else {
                this.loadingIndicator = false;
            }
        });
    }

    /**
     * @name deleteCustomerBranch
     * @param branchId
     * @description deletes customer branch
    */
    deleteCustomerBranch(branchId): void {
        this.customAxios.get(`CustomerBranch/DeleteCustomerBranch?id=${branchId}`).then((response) => {
            console.log(response);
            if (response.data.completed) {
                this.saveSwal.swalOptions = {
                    icon: "success",
                    titleText: response.data.message,
                    showConfirmButton: false,
                    showCancelButton: false,
                    timer: 1500
                };
                this.saveSwal.fire();
                this.getAllCustomerBranch();
            }

        });
    }

    /**
     * @name adddCustomerContent
     * @param branchData
     * @description displays customer contact form popup
    */
    adddCustomerContent(branchData: any) {
        this.selectedBranchData = branchData;
        this.isEdit = false
        this.popupVisible = true;
        this.addCustomerContactFormInitialize();
    }

    /**
     * @name adddCustomerBranch
     * @description displays customer branch form popup
    */
    adddCustomerBranch () {
        this.isEdit = false;
        this.editCustomerBranch = false;
        this.branchPopUp = true;
        this.addCustomerBranchFormInitialization();
    }
    
    /**
     * @name saveCustomerContactForm
     * @param form
     * @description saves customer content data for customer branch
    */
    saveCustomerContactForm(form: FormGroup){
        this.loadingIndicator = true;
        // let contactList = [];
        // if (this.selectedBranchData.customerContactList.length > 0)
        // this.selectedBranchData.customerContactList.forEach((item) => {
        //     contactList.push(item);
        // })
        // contactList.push({
        //     customerContactId: form.value.customerContactId,
        //     customerBranchId: this.selectedBranchData.customerBranchId,
        //     customerId: this.customerId,
        //     contactName: form.value.contactName,
        //     designationId: form.value.designationId,
        //     emailAddress: form.value.emailAddress,
        //     phoneNumber: form.value.phoneNumber,
        //     mobileNumber: form.value.mobileNumber,
        //     faxNumber: form.value.faxNumber,
        //     departmentId: form.value.departmentId,
        //     ext: form.value.ext,
        //     addDateTime: new Date().toISOString(),
        //     addUserId: JSON.parse(localStorage.getItem('userData')).userId,
        //     updateDateTime: new Date().toISOString(),
        //     updateUserId: JSON.parse(localStorage.getItem('userData')).userId,
        //     active: true
        // })
        const payload = {
            // customerId: this.customerId ? this.customerId : 0,
            // salesmanId: this.selectedBranchData.salesmanId,
            // salesDriverId: this.selectedBranchData.salesDriverId,
            // customerBranchId: this.selectedBranchData.customerBranchId,
            // branchName: this.selectedBranchData.branchName,
            // arabicBranchName: this.selectedBranchData.arabicBranchName,
            // postalAddress: this.selectedBranchData.postalAddress,
            // cityId: this.selectedBranchData.cityId,
            // postalCode: this.selectedBranchData.postalCode,
            // companyBranchId: this.selectedBranchData.companyBranchId,
            // emailAddress: this.selectedBranchData.emailAddress,
            // contactNo: this.selectedBranchData.contactNo,
            // faxNo: this.selectedBranchData.faxNo,
            // // customerEmail: form.value.customerEmail,
            // poBox: this.selectedBranchData.poBox,
            // noOfInvoice: this.selectedBranchData.noOfInvoice,
            // specialInstruction: this.selectedBranchData.specialInstruction,
            // isCustomerLocked: this.selectedBranchData.isCustomerLocked,
            // isHeadOffice: this.selectedBranchData.isHeadOffice,
            // accountCode: this.selectedBranchData.accountCode,
            // openingBalance: this.selectedBranchData.openingBalance,
            // openingBalanceDate: this.selectedBranchData.openingBalanceDate,
            // customerContactList: contactList,
            customerContactId: form.value.customerContactId,
            customerBranchId: this.selectedBranchData.customerBranchId,
            customerId: this.customerId,
            contactName: form.value.contactName,
            designationId: form.value.designationId,
            emailAddress: form.value.emailAddress,
            phoneNumber: form.value.phoneNumber,
            mobileNumber: form.value.mobileNumber,
            faxNumber: form.value.faxNumber,
            departmentId: form.value.departmentId,
            ext: form.value.ext,
            addDateTime: new Date().toISOString(),
            addUserId: JSON.parse(localStorage.getItem('userData')).userId,
            updateDateTime: new Date().toISOString(),
            updateUserId: JSON.parse(localStorage.getItem('userData')).userId,
            active: true
        }
        // if(this.editCustomerBranch){
            this.customAxios.post('CustomerContact/UpdateCustomerContact', payload).then((response) => {
                console.log(response);
                if (response.data.completed) {
                    this.loadingIndicator = false;
                    this.popupVisible = false;
                    this.addCustomerContactFormInitialize();
                    this.saveSwal.swalOptions = {
                        icon: "success",
                        titleText: response.data.message,
                        showConfirmButton: false,
                        showCancelButton: false,
                        timer: 1500
                    };
                    this.saveSwal.fire();
                    // this.back();
                    this.getAllCustomerBranch();
                }
                else {
                    this.loadingIndicator = false;
                    notify(response.data.message, 'error', 3000);
                    console.error(response);
                  }
            }).catch(error => {
                this.loadingIndicator = false;
                    notify(error.error, 'error', 3000);
            });
        // }
        // else{
        //     this.customAxios.post('CustomerBranch/AddCustomerBranch', payload).then((response) => {
        //         console.log(response);
        //         if (response.data.completed) {
        //             this.loadingIndicator = false;
        //             this.branchPopUp = false;
        //             this.addCustomerContactFormInitialize();
        //             Swal.fire(
        //                 'Good job!',
        //                 'Your Data is Saved!',
        //                 'success'
        //             )
        //             // this.back();
        //             this.getAllCustomerBranch();
        //         }
    
    
        //     });
        // }
    }

    /**
     * @name deleteCustomerBranchContact
     * @param contactId
     * @description deletes customer contact from customer branch
    */
    deleteCustomerBranchContact(contactId: number){
        this.customAxios.get(`CustomerContact/DeleteCustomerContact?id=${contactId}`).then((response) => {
            console.log(response);
            if (response.data.completed) {
                this.saveSwal.swalOptions = {
                    icon: "success",
                    titleText: response.data.message,
                    showConfirmButton: false,
                    showCancelButton: false,
                    timer: 1500
                };
                this.saveSwal.fire();
                this.getAllCustomerBranch();
            }
            else {
                this.loadingIndicator = false;
                notify(response.data.message, 'error', 3000);
                console.error(response);
              }
        }).catch(error => {
            this.loadingIndicator = false;
                notify(error.error, 'error', 3000);
        });
    }

    /**
     * @name editCustomerContact
     * @param customerContactData
     * @description edits customer contact from customer branch
    */
    editCustomerContact (customerContactData: any) {
        this.addCustomerContent.setValue({
            customerContactId: customerContactData.customerContactId,
            customerBranchId: customerContactData.customerBranchId,
            customerId: customerContactData.customerId,
            contactName: customerContactData.contactName,
            designationId: customerContactData.designationId,
            emailAddress: customerContactData.emailAddress,
            phoneNumber: customerContactData.phoneNumber,
            mobileNumber: customerContactData.mobileNumber,
            faxNumber: customerContactData.faxNumber,
            departmentId: customerContactData.departmentId,
            ext: customerContactData.ext,
        });
        this.popupVisible = true;
        this.editContact = true;
    }

    /**
     * @name updateCustomerContactForm
     * @param form
     * @description update customer contact
    */
    updateCustomerContactForm(contactData: any){
        const payload = {
            customerContactId: contactData.value.customerContactId,
            customerBranchId: contactData.value.customerBranchId,
            customerId: contactData.value.customerId,
            contactName: contactData.value.contactName,
            designationId: contactData.value.designationId,
            emailAddress: contactData.value.emailAddress,
            phoneNumber: contactData.value.phoneNumber,
            mobileNumber: contactData.value.mobileNumber,
            faxNumber: contactData.value.faxNumber,
            departmentId: contactData.value.departmentId,
            ext: contactData.value.ext,
            addDateTime: new Date().toISOString(),
            addUserId: JSON.parse(localStorage.getItem('userData')).userId,
            updateDateTime: new Date().toISOString(),
            updateUserId: JSON.parse(localStorage.getItem('userData')).userId,
            active: true
          }
        this.customAxios.post('CustomerContact/UpdateCustomerContact', payload).then((response) => {
            if (response.data.completed) {
                this.loadingIndicator = false;
                this.popupVisible = false;
                this.editContact = false;
                this.addCustomerContactFormInitialize();
                this.saveSwal.swalOptions = {
                    icon: "success",
                    titleText: response.data.message,
                    showConfirmButton: false,
                    showCancelButton: false,
                    timer: 1500
                };
                this.saveSwal.fire();
                this.getAllCustomerBranch();
            }
            else {
                this.loadingIndicator = false;
                notify(response.data.message, 'error', 3000);
                console.error(response);
              }
        }).catch(error => {
            this.loadingIndicator = false;
                notify(error.error, 'error', 3000);
        });
    }

}
